import { Section } from '@shared/components/Section';
import { oQueE } from '@curso/content/porque';

/**
 * Bloco 3. Responde: o que é HCRM, afinal.
 *
 * Era buraco marcado em âmbar até 19/10, esperando o posicionamento fechado.
 * O roteiro trouxe.
 *
 * O parágrafo do objetivo é o que carrega a posição do grupo, e não deve ser
 * suavizado numa revisão de texto: o curso não promete eliminar o erro. Essa
 * é a diferença entre o que a gente ensina e treinamento de conscientização.
 */
export function OndeChegamos() {
  return (
    <Section id="onde-chegamos" rotulo="O que é" titulo={oQueE.titulo}>
      <p className="prosa">{oQueE.definicao}</p>
      <p className="prosa mt-5">{oQueE.objetivo}</p>
      <p className="prosa mt-5">{oQueE.consequencia}</p>
      <p className="prosa mt-8 text-tinta">{oQueE.remate}</p>
    </Section>
  );
}
